// extracted by mini-css-extract-plugin
export default {"Batches":"BatchesComponent_Batches__ZSh3x","batchCard":"BatchesComponent_batchCard__aCq-9"};